import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Switch, Typography } from "antd";

const { Title, Text } = Typography;

/**
 * Opciones de generación de documentos de un conductor o un vehículo.
 * El FUEC solo se genera si el conductor y el vehículo lo tienen activo; el formulario preoperacional
 * solo aparece en las apps si el conductor y su vehículo lo tienen activo.
 */
const GeneracionDocumentos = ({ values, handleInputChange, entidad }) => {
  const cambiar = (name) => (checked) =>
    handleInputChange({ target: { name, value: checked } });

  const opciones = [
    {
      name: "genera_fuec",
      label: "Genera FUEC",
      ayuda: `La plataforma genera el FUEC solo si el conductor y el vehículo tienen esta opción activa.`,
    },
    {
      name: "genera_preoperacional",
      label: "Genera preoperacional",
      ayuda: `Las apps piden el formulario preoperacional solo si el conductor y su vehículo tienen esta opción activa.`,
    },
  ];

  return (
    <>
      <div
        style={{
          backgroundColor: "#0a2e5c",
          color: "white",
          padding: "8px 16px",
          borderRadius: "4px",
          marginTop: 24,
          marginBottom: 16,
        }}
      >
        <Title level={4} style={{ color: "white", margin: 0 }}>
          Generación de Documentos
        </Title>
      </div>
      <Row gutter={16}>
        {opciones.map((opcion) => (
          <Col xs={24} sm={12} key={opcion.name}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 4 }}>
              <Switch
                checked={values[opcion.name] !== false}
                onChange={cambiar(opcion.name)}
                aria-label={`${opcion.label} (${entidad})`}
              />
              <Text strong>{opcion.label}</Text>
            </div>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {opcion.ayuda}
            </Text>
          </Col>
        ))}
      </Row>
    </>
  );
};

GeneracionDocumentos.propTypes = {
  values: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  entidad: PropTypes.string.isRequired,
};

export default GeneracionDocumentos;
